function convertKPHToMach(num) {
  let eq =
    "Converting " +
    num +
    " kilometers per hour to mach: \n" +
    num +
    " / 1225.044 = ";
  let rep = num / 1225.044;
  return eq + rep.toFixed(3);
}

function convertKPHToMPH(num) {
  let eq =
    "Converting " +
    num +
    " kilometers per hour to miles per hour: \n" +
    num +
    " / 1.609344 = ";
  let rep = num / 1.609344;
  return eq + rep.toFixed(3) ;
}

function convertKPHToKnots(num) {
  let eq =
    "Converting " +
    num +
    " kilometers per hour to knots: \n" +
    num +
    " / 1.852 = ";
  let rep = num / 1.852;
  return eq + rep.toFixed(3);
}

export { convertKPHToMach, convertKPHToMPH, convertKPHToKnots };
